import { PatientCommandParams } from './PatientCommandParams';
import { Command } from './Command';
import { NCZIExtension, NCZIReference } from '../Interfaces/ncziTypes';

export type WritePatientDPNChangeParams = PatientCommandParams & {
	confirmation: {
		createdAt: string;
		changedAt: string;
		versionStatus: string;
		sensitivity: number;
		uncertaintyExpressed: boolean;
		incapableFrom: string;
		capableFrom: string | undefined;
		issueDate: string;
		treatmentAbroad: boolean | undefined;
		note: string | undefined;
		outings:
			| {
					allowedOutings: {
						dateFrom: string;
						timeFrom: string;
						timeTo: string;
					}[];
			  }
			| undefined;
		placeOfStay: undefined;
		incapableReason: {
			reason: NCZIReference;
			alcoholConsumption: boolean | undefined;
			validFrom: string | undefined;
		};
		incapableDuration: {
			anticipatedTerminationDate: string;
			note: string | undefined;
		};
		insuranceExemption: NCZIExtension[] | undefined;
		diagnosis: {
			code: NCZIReference;
			validFrom: string | undefined;
		};
		changeDate: string;
		phone: string | undefined;
		previousVersion: NCZIExtension;
		versionSetId: NCZIExtension | undefined;
	};
};

export const WritePatientDPNChange = (
	params: WritePatientDPNChangeParams,
): Command => {
	return {
		operation: 'ZapisPotvrdenieDPN_v1',
		params,
	};
};
